<template>
    <div
        v-loading="isLoading"
        class="event-form"
    >
        <el-form
            ref="form"
            :rules="rules"
            :model="form"
            label-position="top"
        >
            <el-form-item
                prop="title"
                label="Название"
            >
                <el-input v-model="form.title" />
            </el-form-item>

            <el-form-item
                label="Вступительное слово"
                prop="description"
            >
                <el-input
                    v-model="form.description"
                    type="textarea"
                    :autosize="{ minRows: 6, maxRows: 12}"
                />
            </el-form-item>

            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item
                        label="Регистрация"
                        prop="registration"
                    >
                        <el-date-picker
                            v-model="form.registration"
                            :format="datepickerDateFormat"
                            style="width: 100%;"
                            type="daterange"
                            range-separator=""
                            start-placeholder="Начало"
                            end-placeholder="Конец"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Отель">
                        <el-select
                            v-model="form.hotel_id"
                            style="width: 100%;"
                            placeholder="Отель"
                        >
                            <el-option
                                v-for="hotelItem in hotels"
                                :key="hotelItem.id"
                                style="width: 100%;"
                                :label="hotelItem.title"
                                :value="hotelItem.id"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item
                        label="Пройдет"
                        prop="dates"
                    >
                        <el-date-picker
                            v-model="form.dates"
                            :format="datepickerDateFormat"
                            style="width: 100%;"
                            type="daterange"
                            range-separator=""
                            start-placeholder="Начало"
                            end-placeholder="Конец"
                        />
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item
                        label="Предоплата"
                        prop="prepay"
                    >
                        <el-input
                            v-model.number="form.prepay"
                            type="number"
                        >
                            <span slot="suffix">
                                Руб.
                            </span>
                        </el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="Детская скидка">
                        <el-input v-model="form.childrenProgramPrice">
                            <span slot="suffix">
                                Руб.
                            </span>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item
                        label="Текст о трансфере"
                        prop="transfer_text"
                    >
                        <el-input
                            v-model="form.transfer_text"
                            type="textarea"
                            :autosize="{ minRows: 6, maxRows: 10}"
                        />
                    </el-form-item>
                </el-col>

                <el-col
                    v-loading="isPricesLoading"
                    :span="12"
                >
                    <!-- Room types -->
                    <el-row
                        v-for="(category, index) in form.roomPrices"
                        :key="category.room_category_id"
                        :gutter="20"
                        style="margin-top: 0;"
                    >
                        <el-col :span="12">
                            <el-form-item
                                :prop="`roomPrices.${index}.price`"
                                :label="category.room_category_title"
                                :rules="roomTypePriceRules"
                            >
                                <el-input
                                    v-model.number="form.roomPrices[index].price"
                                    type="number"
                                    min="1"
                                    placeholder="Цена"
                                >
                                    <span slot="suffix">
                                        Руб.
                                    </span>
                                </el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item
                                :prop="`roomPrices.${index}.redeem_price`"
                                :rules="roomTypeRedeemPlaceRules"
                                :label="form.roomPrices[index].redeem_price === 0 ? 'Без выкупа' : 'Выкуп'"
                            >
                                <el-input
                                    v-model.number="form.roomPrices[index].redeem_price"
                                    type="number"
                                    min="0"
                                    placeholder="Выкуп"
                                >
                                    <span slot="suffix">
                                        Руб.
                                    </span>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-checkbox v-model="form.registration_suspended">
                                Остановить прием оплат
                            </el-checkbox>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>

            <!-- Additional messages -->
            <el-row
                v-for="(message, index) in form.additionalMessages"
                :key="index"
                :gutter="20"
            >
                <el-col :span="16">
                    <el-form-item label="Текст">
                        <el-input
                            v-model="form.additionalMessages[index].text"
                            type="textarea"
                            :autosize="{ minRows: 6, maxRows: 10}"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Тип текста">
                        <el-select
                            v-model="form.additionalMessages[index].type"
                            style="width: 100%;"
                            placeholder="Выберите тип"
                        >
                            <el-option
                                v-for="type in availableAdditionalMessageTypes"
                                :key="type.type"
                                style="width: 100%;"
                                :label="type.title"
                                :value="type.type"
                            />
                        </el-select>
                        <el-button
                            type="warning"
                            plain
                            style="margin-top: 20px;"
                            @click="_removeAdditionalMessageByIndex(index)"
                        >
                            Удалить
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <el-row>
            <el-popover
                :disabled="!isPersonalImported"
                :content="personalIsImportedText"
                trigger="hover"
            >
                <el-button
                    v-if="isEditMode"
                    slot="reference"
                    type="primary"
                    plain
                    @click="_openImportWindow"
                >
                    <i class="fas fa-file-import" />
                    Персонал
                </el-button>
            </el-popover>

            <el-button
                style="margin-left: 10px;"
                type="primary"
                plain
                icon="el-icon-plus"
                :disabled="!isAddAdditionalMessageButtonAvailable"
                @click="_addAdditionalMessage"
            >
                Добавить сообщение
            </el-button>
            <el-button
                type="primary"
                @click="trySend"
            >
                {{ buttonText }}
            </el-button>
        </el-row>
        <event-select-popup
            ref="importPopUp"
            :event-id="eventId"
        />
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { DATES, ROUTES } from '@/enums';
import { Hotel, Event } from '@/api';
import {
    mapRoomCategoryResourceToRoomPrice,
    mapRoomPriceResourceToRoomPrice
} from '@/modules/event/mappers';
import { mapState, mapActions } from 'vuex';
import EventSelectPopup from '@/modules/event/components/personnelImport/EventSelectPopup';

export default {
    name: 'EventForm',
    components: { EventSelectPopup },
    props: {
        eventId: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            isLoading: false,
            /** @type {HotelResource[]} */
            hotels: [],
            additionalMessageTypes: [],
            form: {
                /** @type {RoomPrice[]} */
                roomPrices: [],
                additionalMessages: []
            },
            /**
             * При создании события при выборе
             * отеля в списке сюда помещается выбранный отель.
             * @type {HotelResource | null}
             */
            selectedHotel: null
        };
    },

    computed: {
        ...mapState('config', [
            'datepickerDateFormat'
        ]),

        ...mapState('event', {
            event: 'resource'
        }),

        isPricesLoading() {
            return this.form.roomPrices.length === 0;
        },

        availableAdditionalMessageTypes() {
            return this.additionalMessageTypes
                .filter(x => !this.form.additionalMessages.find(y => y.type === x.type));
        },

        isAddAdditionalMessageButtonAvailable() {
            return !!this.availableAdditionalMessageTypes.length;
        },

        isPersonalImported() {
            return !!_.get(this.event, 'relationships.stuffMovedFromEvent', false);
        },

        personalIsImportedText() {
            return `На этот фестиваль уже перенесен персонал с фестиваля ${_.get(this.event, 'relationships.stuffMovedFromEvent.attributes.title', '')}`;
        },

        rules() {
            return {
                name: [
                    { required: true, message: 'Введите название фестиваля' }
                ],

                hotel: [
                    { required: true, message: 'Укажите отель' }
                ],

                dates: [
                    { required: true, message: 'Укажие даты проведения' },
                    {
                        validator: (rule, value, callback) => {
                            if (!value || !value[0] || !value[1]) {
                                return callback(new Error('Укажие даты проведения'));
                            }
                            const eventStart = moment(value[0]);
                            const eventEnd = moment(value[1]);
                            if (eventStart.diff(eventEnd) >= 0) {
                                return callback(
                                    new Error('Дата начала события должна быть раньше даты завершения')
                                );
                            }
                            const registration = this.form.registration;
                            if (!registration || !registration[0] || !registration[1]) {
                                return callback(new Error('Укажие даты регистрации'));
                            }
                            const registrationStart = moment(registration[0]);
                            const registrationEnd = moment(registration[1]);
                            if (eventStart.diff(registrationEnd) < 0) {
                                return callback(
                                    new Error('Дата начала события должна быть позже даты завершения регистрации')
                                );
                            }
                            this.$refs.form.validateField('registration');
                            callback();
                        },
                        trigger: 'change'
                    }
                ],

                registration: [
                    { required: true, message: 'Укажие даты регистрации' },
                    {
                        validator: (rule, value, callback) => {
                            if (!value || !value[0] || !value[1]) {
                                return callback(new Error('Укажие даты регистрации'));
                            }
                            const registrationStart = moment(value[0]);
                            const registrationEnd = moment(value[1]);

                            const dates = this.form.dates;
                            if (!dates || !dates[0] || !dates[1]) {
                                return callback(new Error('Укажие даты события'));
                            }
                            const eventStart = moment(dates[0]);
                            const eventEnd = moment(dates[1]);
                            if (registrationEnd.diff(registrationStart) <= 0) {
                                return callback(
                                    new Error('Дата начала регистрации должна быть позже даты завершения')
                                );
                            }
                            callback();
                        },
                        trigger: 'change'
                    }
                ]
            };
        },

        roomTypePriceRules() {
            return [
                {
                    validator: (rule, value, callback) => {
                        if (value <= 0) {
                            return callback(new Error('Цена обязательна'));
                        }
                        callback();
                    }
                }
            ];
        },

        roomTypeRedeemPlaceRules() {
            return [
                {
                    validator: (rule, value, callback) => {
                        if (value < 0) {
                            return callback(new Error('Цена не может быть меньше 0'));
                        }
                        callback();
                    }
                }
            ];
        },

        isEditMode() {
            return !!this.eventId;
        },

        /**
         * @returns {HotelResource | null}
         */
        hotel() {
            return this.$prop('event.relationships.hotel', null);
        },

        /**
         * @returns {RoomCategoryResource[]}
         */
        hotelRoomCategories() {
            return this.$prop('selectedHotel.relationships.room_categories', []);
        },

        /**
         * @returns {RoomPriceResource[]}
         */
        hotelRoomPrices() {
            return this.$prop('event.relationships.room_prices', []);
        },

        buttonText() {
            return this.isEditMode ? 'Сохранить' : 'Создать';
        }
    },

    watch: {
        'form.hotel_id'(newHotelId) {
            this._onHotelChanged(newHotelId);
        },

        hotelRoomCategories() {
            this._onHotelRoomCategoriesChanged();
        }
    },

    async mounted() {
        this.isLoading = true;
        this._getHotels();
        this._getAdditionalMessageTypes();
        if (this.eventId) {
            await this._getEvent();
        }
        this.isLoading = false;
    },

    methods: {
        ...mapActions('event', [
            'getResource'
        ]),

        _openImportWindow() {
            if (this.isPersonalImported) {
                return this.$message.info(this.personalIsImportedText);
            }
            this.$refs.importPopUp.open();
        },

        trySend() {
            this.$refs.form.validate(isValid => {
                if (!isValid) {
                    this.$message.warning('Проверьте форму');
                    return;
                }
                this.isLoading = true;
                this._send().then(() => {
                    this.isLoading = false;
                });
            });
        },

        /**
         * @param {UUID | null} hotelId
         * @private
         */
        _onHotelChanged(hotelId) {
            this._getSelectedHotel(hotelId);
        },

        _onHotelRoomCategoriesChanged() {
            /** @type {RoomPrice[]} */
            const roomPrices = this._getRoomPricesFromEvent();
            /**
             * @param {RoomCategoryResource} x
             * @return {RoomPrice}
             */
            const mapper = x => {
                const roomPrice = roomPrices.find(y => y.room_category_id === x.id);
                const price = _.get(roomPrice, 'price', 0);
                const redeemPrice = _.get(roomPrice, 'redeem_price', 0);
                return mapRoomCategoryResourceToRoomPrice(
                    this.eventId,
                    price,
                    redeemPrice,
                    x
                );
            };
            this.form.roomPrices = this.hotelRoomCategories
                .map(mapper);
        },

        /**
         * @param {UUID | null} hotelId
         * @private
         */
        _getSelectedHotel(hotelId) {
            if (!hotelId) {
                this.selectedHotel = null;
                return;
            }
            /**
             * @param{HotelResource} hotel
             */
            const onResponse = hotel => {
                this.selectedHotel = hotel;
            };
            Hotel.show({ hotelId })
                .then(onResponse)
                .catch(e => {
                    this.$message.error('Не удалось получить информацию об отеле');
                });
        },

        async _getEvent() {
            try {
                /** @param {EventResource} event */
                await this.getResource({ eventId: this.eventId });
                this.form = this._formFromEvent();
            } catch (e) {
                this.$message.error('Событие не найдено');
                this.router.push({
                    name: ROUTES.EVENT.LIST
                });
            }
        },

        _send() {
            const data = this._formToCreateEventRequest();
            if (this.isEditMode) {
                return Event.update(data)
                    .then(response => {
                        this.$message.success('Событие обновлено');
                    })
                    .catch(e => {
                        this.$message.error('Не удалось обновить событие');
                    });
            } else {
                return Event.store(data)
                    .then(response => {
                        this.$message.success('Событие создано');
                        //this._reset();
                        this.$router.push({ name: 'event.list' });
                    })
                    .catch(e => {
                        this.$message.error('Не удалось создать событие');
                    });
            }
        },

        _reset() {
            this.form = {};
        },

        /**
         * @returns {CreateEventRequest}
         * @private
         */
        _formToCreateEventRequest() {
            const start = moment(this.form.dates[0]);
            const end = moment(this.form.dates[1]);
            const registrationStart = moment(this.form.registration[0]);
            const registrationEnd = moment(this.form.registration[1]);
            /** @type {CreateEventRequest} */
            const data = {
                title: this.form.title,
                description: this.form.description,
                transfer_text: this.form.transfer_text,
                start_at: start.format(DATES.SHORT_FORMAT),
                end_at: end.format(DATES.SHORT_FORMAT),
                registration_start_at: registrationStart.format(DATES.SHORT_FORMAT),
                registration_end_at: registrationEnd.format(DATES.SHORT_FORMAT),
                prepay: this.form.prepay,
                children_program_price: this.form.childrenProgramPrice,
                hotel_id: this.form.hotel_id,
                room_prices: this._getRoomPrices(),
                registration_suspended: this.form.registration_suspended
            };
            if (this.isEditMode) {
                data.event_id = this.eventId;
            }
            return data;
        },

        /**
         * @returns {RoomPrice[]}
         * @private
         */
        _getRoomPrices() {
            return this.form.roomPrices;
        },

        /**
         * @return {RoomPrice[]}
         * @private
         */
        _getRoomPricesFromEvent() {
            return this.hotelRoomPrices
                .map(mapRoomPriceResourceToRoomPrice);
        },

        _formFromEvent() {
            return {
                title: this.event.attributes.title,
                description: this.event.attributes.description,
                transfer_text: this.event.attributes.transfer_text,
                prepay: this.event.attributes.prepay,
                childrenProgramPrice: this.event.attributes.children_program_price,
                hotel_id: this.event.attributes.hotel_id,
                registration_suspended: this.event.attributes.registration_suspended,
                dates: [
                    this.event.attributes.start_at,
                    this.event.attributes.end_at
                ],
                registration: [
                    this.event.attributes.registration_start_at,
                    this.event.attributes.registration_end_at
                ],
                roomPrices: [],
                additionalMessages: []
            };
        },

        _addAdditionalMessage() {
            if (!this.availableAdditionalMessageTypes.length) {
                return;
            }
            this.form.additionalMessages.push({
                text: '',
                type: null
            });
        },

        _removeAdditionalMessageByIndex(index) {
            this.form.additionalMessages.splice(index, 1);
        },

        _getHotels() {
            /** @param {HotelResource[]} hotels */
            const onResponse = hotels => {
                this.hotels = hotels.map(x => ({
                    id: x.id,
                    title: x.attributes.title
                }));
                this.form.hotel_id = _.get(this.hotels, '[0].id', null);
            };
            Hotel.getAllHotels()
                .then(onResponse)
                .catch(() => {});
        },

        _getAdditionalMessageTypes() {
            this.additionalMessageTypes = [
                {
                    type: 'on_registration_top_message',
                    title: 'Сообщениие при регистрации перед формой'
                },
                {
                    type: 'on_registration_success_message',
                    title: 'Сообщениие при успешной регистрации'
                }
            ];
        }
    }
};
</script>

<style lang="scss">
@import "@vars";

.event-form {
    max-width: 510px;
}

</style>
